import request from '@/utils/http';
import { SRM_FILE_PRE } from '../constant/constant.js';

const SRM = '/api-srm-web';
// 供应商-电子报价头信息
export const headerMsg = (params) => {
    return request({
        url: `${SRM}/bid/getBidDtlHeader`,
        method: 'post',
        data: params
    });
};
// 供应商-电子报价自定义列
export const getTmptDef = (params) => {
    return request({
        url: `${SRM}/bid/getBidQuoteTmptDef`,
        method: 'post',
        data: params
    });
};
// 供应商-电子报价自定义列
export const getSupTmptDef = (params) => {
    return request({
        url: `${SRM}/bid/portal/getBidQuoteTmptDef`,
        method: 'post',
        data: params
    });
};
// 供应商-表格信息
export const getDetails = (params) => {
    return request({
        url: `${SRM}/bid/portal/selectThinDtlDetails`,
        method: 'post',
        data: params
    });
};
// 供应商-表格信息父级数据
export const getDetailsParents = (params) => {
    return request({
        url: `${SRM}/bid/portal/selectThinDtlDetailsParents`,
        method: 'post',
        data: params
    });
};
// 供应商-表格信息子级数据
export const getDetailsSon = (params) => {
    return request({
        url: `${SRM}/bid/portal/selectThinDtlDetailsSon`,
        method: 'post',
        data: params
    });
};
// 供应商-保存报价信息
export const saveBidMsg = (params, data) => {
    return request({
        url: `${SRM}/bid/portal/updateDtlDetails/${params.tenderCode}/${params.supplierCode}`,
        method: 'post',
        data: data
    });
};
// 供应商-提交报价信息
export const submitBidMsg = (params) => {
    return request({
        url: `${SRM}/bid/portal/submitBidTenderSupplier`,
        method: 'post',
        data: params
    });
};
// 供应商-导出报价信息
export const exportBidMsg = (params) => {
    return request({
        url: `${SRM_FILE_PRE}/bid/portal/exportBidTenderSupplier/${params.tenderCode}/${params.supplierCode}/${params.bidNo}?identificationCode=${params.identificationCode}`,
        method: 'get'
    });
};
// 管理端-轮次报价小卡片
export const getRoundCard = (params) => {
    return request({
        url: `${SRM}/bid/bidDtlHeads`,
        method: 'post',
        data: params
    });
};
// 管理端-轮次报价-保存
export const saveManageMsg = (data, id) => {
    return request({
        url: `${SRM}/bid/bidDtlHead/${id}`,
        method: 'put',
        data: data
    });
};
// 管理端-轮次报价-发布
export const publishManageMsg = (params) => {
    return request({
        url: `${SRM}/bid/publish`,
        method: 'post',
        data: params
    });
};
// 管理端-轮次报价-查询报价明细表头信息
export const getDetailsTmptDef = (params) => {
    return request({
        url: `${SRM}/bid/getBidQuoteTmptDef`,
        method: 'post',
        data: params
    });
};
// 管理端-轮次报价-查询报价明细表格信息
export const getManageDetails = (params) => {
    return request({
        url: `${SRM}/bid/selectDtlDetails`,
        method: 'post',
        data: params
    });
};
// 管理端-轮次报价-报价加时
export const addBidTime = (params) => {
    return request({
        url: `${SRM}/bid/addTime`,
        method: 'post',
        data: params
    });
};
// 管理端-轮次报价-公布拦标价
export const publishBidPrice = (params) => {
    return request({
        url: `${SRM}/bid/publishQuoteRange`,
        method: 'post',
        data: params
    });
};
// 管理端-轮次报价-发起下一轮
export const nextTender = (params) => {
    return request({
        url: `${SRM}/bid/nextTender`,
        method: 'post',
        data: params
    });
};
// 管理端-轮次报价-入围、自动入围、中标判断
export const checkDtlDetailTiedFirst = (params) => {
    return request({
        url: `${SRM}/bid/checkDtlDetailTiedFirst`,
        method: 'post',
        data: params
    });
};
// // TODO
// export const kbzbValidate = (params) => {
//     return request({
//         // url: `${SRM}/bid/bidDtlDetailWonOpenAll`,
//         url: `/v50/kbzbValidate`,
//         method: 'post',
//         data: params
//     });
// };
// 管理端-轮次报价-开标
export const wonOpenAll = (params) => {
    return request({
        url: `${SRM}/bid/bidDtlDetailWonOpenAll`,
        method: 'post',
        data: params
    });
};
// 管理端-轮次报价-分批开标
export const wonInTurn = (params) => {
    return request({
        url: `${SRM}/bid/bidDtlDetailWonOpenInTurn`,
        method: 'post',
        data: params
    });
};
// 管理端-轮次报价-入围
export const bidWonRw = (params) => {
    return request({
        url: `${SRM}/bid/bidDtlDetailWonRw`,
        method: 'post',
        data: params
    });
};
// 管理端-轮次报价-自动入围
export const bidWonAuto = (params) => {
    return request({
        url: `${SRM}/bid/bidDtlDetailWonAuto`,
        method: 'post',
        data: params
    });
};
// 管理端-轮次报价-未入围
export const cancelRw = (params) => {
    return request({
        url: `${SRM}/bid/bidDtlDetailWonCancelRw`,
        method: 'post',
        data: params
    });
};
// 管理端-轮次报价-中标
export const WonZb = (params) => {
    return request({
        url: `${SRM}/bid/bidDtlDetailWonZb`,
        method: 'post',
        data: params
    });
};
// 管理端-轮次报价-流标
export const wonFailed = (params) => {
    return request({
        url: `${SRM}/bid/bidDtlDetailwonFailed`,
        method: 'post',
        data: params
    });
};
// 管理端-轮次报价-弃标
export const wonGiveUp = (params) => {
    return request({
        url: `${SRM}/bid/bidDtlDetailWonGiveUp`,
        method: 'post',
        data: params
    });
};
// 管理端-轮次报价-明细保存
export const saveDetailsMsg = (data, tenderCode) => {
    return request({
        url: `${SRM}/bid/updateDtlDetails/${tenderCode}`,
        method: 'post',
        data: data
    });
};

// 管理端-轮次报价-轮次预警
export const bidTenderSuppliers = (data, tenderCode) => {
    return request({
        url: `${SRM}/bid/queryBidTenderSuppliers`,
        method: 'post',
        data: data
    });
};
// 管理端-轮次报价-删除第一轮
export const bidDelOneRound = (data, url) => {
    return request({
        url: `${SRM}/bid/revertQuote${url}`,
        method: 'post',
        data: data
    });
};
// 管理端-轮次报价-拦标价校验提示
export const bidPriceCheck = (data, tenderCode) => {
    return request({
        url: `${SRM}/bid/checkQuoteRange/${tenderCode}`,
        method: 'post',
        data: data
    });
};

// 管理端-轮次报价-查看参考成本
export const checkConsultCost = (params) => {
    return request({
        url: `${SRM}/bid/getReferenceCostNew`,
        method: 'post',
        data: params
    });
};
// 管理端-轮次报价-导出参考成本
export const exportConsultCost = (params) => {
    return request({
        url: `${SRM_FILE_PRE}/bid/exportReferenceCost`,
        method: 'post',
        data: params,
        responseType: 'arraybuffer'
    });
};

// 管理端-轮次报价-竞价倒计时
export const getCountDown = (params) => {
    return request({
        url: `${SRM}/bid/getCountDown`,
        method: 'post',
        data: params
    });
};

// 实时获取竞拍报价简约版弹框数据
export const realTimeBiddingList = (params) => {
    return request({
        url: `${SRM}/bid/realTimeBiddingList`,
        method: 'post',
        data: params
    });
};

// 供应商发布竞拍报价
export const publishBidding = (params) => {
    return request({
        url: `${SRM}/bid/publishBidding`,
        method: 'post',
        data: params
    });
};

// 第一轮 报价的时候添加供应商--查询
export const selectSupplierToQuoted = (params) => {
    return request({
        url: `${SRM}/bid/selectSupplierToQuoted`,
        method: 'post',
        data: params
    });
};

// 第一轮 报价的时候添加供应商--添加
export const addSupplierToFirstTender = (params) => {
    return request({
        url: `${SRM}/bid/addSupplierToFirstTender`,
        method: 'post',
        data: params
    });
};

// 匹配标准成本
export const matchStandardCosts = (id) => {
    return request({
        url: `${SRM}/bid/matchStandardCosts/${id}`,
        method: 'post'
    });
};

// 导出
export const exportBidTender = (url, tenderCode, allowQuote) => {
    return request({
        url: `${url}${tenderCode}/${allowQuote}`,
        method: 'get'
    });
};

// 查询导入状态
export const getImportBidTenderStatus = params => {
    return request({
        url: `${SRM_FILE_PRE}/bid/portal/importBidTenderSupplierStatus/${params.tenderCode}/${params.supplierCode}`,
        method: 'get'
    });
};